// extracted by mini-css-extract-plugin
export default {"element":"ContentBox-module--element--506c5","emphasis":"ContentBox-module--emphasis--65d98"};